import { get } from 'lodash'

export default class JqFormToVueForm {
    defaultParsers() {
        return {
            text: this.inputParser,
            hidden: this.hiddenParser,
            //select: this.selectParser,
            'checkbox-group': this.chkboxGroupParser,
            select: this.selectParserImproved,
        }
    }

    getParsers() {
        return this.parsers
    }

    getParser(type) {
        return this.parsers[type] || null
    }

    // setParser(type, parser) {}

    constructor(schema) {
        this.schema = schema
        this.model = {}
        this.parsers = this.defaultParsers()
        this.parsed_schema = this.parseSchema()
    }

    getSchema() {
        let schema = this.parsed_schema
        //schema[schema.length-1].fields.push(this.getSubmit())

        return schema //.reduce((acc, val) => acc.concat(val), [])
    }

    getModel() {
        return this.model
    }

    parseSchema() {
        let _groups = this.schema.reduce(
            (acc, field) => {
                if (field.type == 'header') {
                    acc.groups.push(acc.currentGroup)
                    acc.currentGroup = {
                        legend: field.label,
                        fields: [],
                    }
                } else {
                    acc.currentGroup.fields.push(field)
                }

                return acc
            },
            { currentGroup: { legend: '', fields: [] }, groups: [] }
        )

        // Push Last group into 'groups'
        _groups.groups.push(_groups.currentGroup)

        // Filter out any groups that don't have any fields
        let groups = _groups.groups.filter(group => {
            return group.fields.length > 0 ? true : false
        })

        // Parse groupfields
        return groups.map(group => {
            let fields = group.fields
                .map(field => {
                    let parser = this.getParser(field.type)

                    if (!parser) {
                        //// console.log('Missing parser', field)
                        return
                    }

                    return parser(field, this)
                })
                .filter(field => {
                    return typeof field !== 'undefined'
                })
            return {
                legend: group.legend,
                fields: fields,
            }
        })

        /*return this.schema.map( (field) => {
				let parser = this.getParser(field.type)

				if(!parser){
					//// console.log('Missing parser', field)
					return;
				}

				return parser(field, this)
			})
			.filter( (field) => {
				return typeof field !== 'undefined'
			})*/
    }

    inputParser(field, instance) {
        //// console.log('hiddenParser', instance)
        instance.model[field.name] = field.value || ''
        // console.log('REQUIRED', field)
        return {
            type: 'input',
            autocomplete: false,
            inputType: field.subtype || 'text',
            label: field.label,
            required: get(field, 'required', false), //field.required || false,
            placeholder: field.placeholder || '',
            hint: field.description || '',
            model: field.name,
        }
    }

    hiddenParser(field, instance) {
        //// console.log('hiddenParser', instance)
        instance.model[field.name] = field.value || ''
        return {
            type: 'input',
            inputType: 'hidden',
            model: field.name,
        }
    }
    checkboxParser(field, instance) {
        instance.model[field.name] = field.values[0].selected || null
        // console.log('checkboxParser', field)
        return {
            type: 'switch',
            label: field.label + '(' + field.values[0].label + ')',
            model: field.name,
            textOn: 'xxx',
            valueOn: field.values[0].value,
            textOff: 'yyy',
            valueOff: null,
        }
    }
    chkboxGroupParser(field, instance) {
        // Redirect to checkbox if there only is 1 value
        if (field.values.length == 1) {
            return instance.checkboxParser(field, instance)
        }

        // console.log('checkbox-group', field)
        instance.model[field.name] = []
        let values = field.values.map(value => {
            return {
                name: value.label,
                value: value.value,
            }
        })

        return {
            type: 'vueMultiSelect',
            placeholder: field.description,
            label: field.label,
            model: field.name,
            values: values,
            selectOptions: {
                trackBy: 'value',
                multiple: true,
                key: 'value',
                label: 'name',
                searchable: field.values.length > 10 ? true : false,
                closeOnSelect: false,
                allowEmpty: true,
                hideSelected: true,
            },
        }
    }

    selectParserImproved(field, instance) {
        instance.model[field.name] = []
        let values = field.values.map(value => {
            return {
                name: value.label,
                value: value.value,
            }
        })

        let multiple = typeof field.multiple !== 'undefined' ? true : false

        return {
            type: 'vueMultiSelect',
            placeholder: field.description,
            label: field.label,
            model: field.name,
            required: get(field, 'required', false), // field.required || false,
            values: values,
            selectOptions: {
                trackBy: 'value',
                multiple: multiple,
                key: 'value',
                label: 'name',
                searchable: field.values.length > 10 ? true : false,
                closeOnSelect: !multiple,
                allowEmpty: true,
            },
        }
    }
}
